class Image {
    constructor(request) {
        this.request = request;
    }

    GetImages(code) {
        return this.request.requestData(`https://cdn.ngnw.ph/lists/carousel/list/${code}.json`);
    }
}

export default Image;